// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"500682b6be2806a3f1a4","873":"d70691a7a7b07bc7c555"}[chunkId] + ".js";
};